import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const transformationQuery = createApi({
  baseQuery,
  reducerPath: "transformationQueries",
  endpoints: (builder) => ({
    createTransformation: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.transformation.path)}`,
        method: "POST",
        body: data,
      }),
    }),
    updateTransformation: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.transformation.path)}`,
        method: "PUT",
        body: data,
      }),
    }),
    getTransformation: builder.query<any, any>({
      query: ({ entity_name }) => ({
        url: `${formatString(endPoints.transformation.getTransformation, {
          key: urlKeys.entity_name,
          value: entity_name,
        })}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateTransformationMutation,
  useUpdateTransformationMutation,
  useLazyGetTransformationQuery,
} = transformationQuery;
